import React, { useEffect, useMemo, useState } from 'react'
import { Col, Modal, Row } from "react-bootstrap";
import { TextColored } from '../../typography';
import CustomButton from '../../buttons/Button';
import { TableRender } from '../../Table/TableRender';
import { Form } from "react-bootstrap";
import { CustomLoader } from '../../tabla/Tabla';
import { type_aplicaciones } from '../../../constants/typeaplicaciones';
import NumberFormat from 'react-number-format';

const Modalaplicaciones = ({
    show,
    setShow,
    rowsDoc,
    rowsCxc,
    rowsLeasing,
    setselectAplicacionDoc,
    setselectAplicacionCxc,
    setselectAplicaionLeasing,
    tiposeleccion,
    setTiposeleccion,
    showTables,
    totalAplicaciones,
    handleSaveAplicaciones,
    parametros_paa,
    handleCloseModal
}) => {


  return (

    <Modal show={show} onHide={() => setShow(false)} size='xl' backdrop="static">
      <Modal.Header className="costs-header">
        <div className="d-flex justify-content-center w-100">
          <TextColored children="Aplicaciones" type="dark" size={2.5} weight={600} />
        </div>
      </Modal.Header>
      <Modal.Body className='mb-1 d-flex flex-column' style={{
        gap:'20px'
      }}>
        <div className='d-flex justify-content-center align-content-center' style={{
            gap:'1rem'
          }}>
          <div className='d-flex' style={{
            gap:'0.5rem'
          }}> 
            <Form.Check
              type="radio"
              id={'0-selecction'}
              checked={tiposeleccion === type_aplicaciones.OBLIGATORIO}
              onChange={(e) => {
                setTiposeleccion(type_aplicaciones.OBLIGATORIO)
              }}
            />
            <label htmlFor="0-selecction" className='mt-1'>Obligatorio</label>
          </div>

          {/* <div className='d-flex' style={{
            gap:'0.5rem'
          }}> 
            <Form.Check
              type="radio"
              id={'1-selecction'}
              checked={tiposeleccion === type_aplicaciones.NO_OBLIGATORIO}
              onChange={(e) => {
                setTiposeleccion(type_aplicaciones.NO_OBLIGATORIO)
              }}
            />
            <label htmlFor="1-selecction" className='mt-1'>No obligatorio</label>
          </div> */}

          <div className='d-flex' style={{
            gap:'0.5rem'
          }}> 
            <Form.Check
              type="radio"
              id={'2-selecction'}
              checked={tiposeleccion === type_aplicaciones.TODOS}
              onChange={(e) => {
                setTiposeleccion(type_aplicaciones.TODOS)
              }}
            />
            <label htmlFor="2-selecction" className='mt-1'>Todos</label>
          </div>

        </div>
          { showTables ?
            <>
              { 
                ( parametros_paa.is_app_dte && rowsDoc.rows.length > 0) &&
                <div>
                  <div 
                    className='d-flex' 
                    style={{
                      justifyContent:'space-between',
                      alignItems:'center',
                      marginRight: '8px',
                      marginLeft: '8px'
                    }}
                  >
                    <TextColored children="Remplazo de Facturas" type="dark" size={1.3}/>
                      <NumberFormat
                        name='totaldt'
                        value={totalAplicaciones.doc}
                        // data-key={info.row.original.idcheck}
                        style={{ 
                          fontSize: 'large',
                          fontWeight: '500',
                          textAlign: 'end'
                        }}
                        displayType={"text"}
                        decimalScale={0}
                        allowNegative={false}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        prefix={'$'}
                      />
                  </div>
                  <div className='mt-3'>  
                    <TableRender
                      datos={rowsDoc}
                      allowGlobalFilter={false}
                      handleChangeCheck={( selectedRows )=>{
                        setselectAplicacionDoc(selectedRows)
                      }}
                      fontSizeTable={'13px'}
                      itemsPerPageDefault={20}
                    />
                  </div>
                  <hr/>
                </div>
              }
              
              { 
                ( parametros_paa.is_app_cxc && rowsCxc.rows.length > 0) &&
                <div>
                  <div 
                    className='d-flex' 
                    style={{
                      justifyContent:'space-between',
                      alignItems:'center',
                      marginRight: '8px',
                      marginLeft: '8px'
                    }}
                  >
                     <TextColored children="Pago de cuentas por Cobrar" type="dark" size={1.3} />
                      <NumberFormat
                        name='totaldt'
                        value={totalAplicaciones.cxc}
                        style={{ 
                          fontSize: 'large',
                          fontWeight: '500',
                          textAlign: 'end'
                        }}
                        displayType={"text"}
                        decimalScale={0}
                        allowNegative={false}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        prefix={'$'}
                      />
                  </div>
                  <div className='mt-3'>
                    <TableRender
                      datos={rowsCxc}
                      allowGlobalFilter={false}
                      handleChangeCheck={( selectedRows )=>{
                        setselectAplicacionCxc(selectedRows)
                      }}
                      fontSizeTable={'13px'}
                      itemsPerPageDefault={1000}
                      showPagination={false}
                    />
                  </div>
                  <hr/>
                  </div>
              }
              
              { 
                ( parametros_paa.is_app_lesing && rowsLeasing.rows.length > 0) &&
                <div>
                  <div 
                    className='d-flex' 
                    style={{
                      justifyContent:'space-between',
                      alignItems:'center',
                      marginRight: '8px',
                      marginLeft: '8px'
                    }}
                  >
                    <TextColored  className='mb-3' children="Pago de cuotas leasing" type="dark" size={1.3}/>
                    <NumberFormat
                      name='totaldt'
                      value={totalAplicaciones.cuotas}
                      style={{ 
                        fontSize: 'large',
                        fontWeight: '500',
                        textAlign: 'end'
                      }}
                      displayType={"text"}
                      decimalScale={0}
                      allowNegative={false}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      prefix={'$'}
                    />
                  </div>
                
                  <div className='mt-3'>
                    <TableRender
                      datos={rowsLeasing}
                      allowGlobalFilter={false}
                      handleChangeCheck={( selectedRows )=>{
                        setselectAplicaionLeasing(selectedRows)
                      }}
                      fontSizeTable={'13px'}
                      itemsPerPageDefault={1000}
                      showPagination={false}
                    />
                  </div>
                </div>
              }
            </>
            :
            <div className='d-flex justify-content-center'>
              <CustomLoader style={{ width:300 }} />
            </div>
          }
          
      </Modal.Body>

      <Modal.Footer>
        <Row className="w-100 justify-content-end m-auto">
          <Col md={2} sm={5} xs={5}>
            <CustomButton
              children={"Grabar"}
              onClick={handleSaveAplicaciones}
            />
          </Col>
          <Col md={2} sm={5} xs={5}>
            <CustomButton
              children={"Cerrar"}
              className='w-100'
              style={{
                background: "#ccc",
                borderColor: "#ccc",
              }}
              onClick={handleCloseModal}
            />
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  )
}

export default Modalaplicaciones;
